import React, { useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, useTheme, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer, List, ListItem, ListItemText } from '@mui/material';
import { Box } from '@mui/system';
import InputStylefield from '../../assets/InputStylefield';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import VideocamIcon from '@mui/icons-material/Videocam';
import { enqueueSnackbar } from 'notistack';
import { deleteJobById } from '../../actions/userAuth';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PhoneIcon from '@mui/icons-material/Phone';

export default function CoachUpcomingServiceSessions() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const theme = useTheme();

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = () => {
        setChecked(!checked);
    };

    const navigate = useNavigate();


    const data = [
        { id: 1, header1: 'Ackrolix Innovation', header2: 'Data 2', header3: 'Data 3', header4: '24- April 2023', header5: 'Data 5', header6: 'Deactivate', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'UI UX Designer', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Activate', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Deactivate', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Closing Soon', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Deleted', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Active', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    const handleDeleteJob = () => {
        // var temp = [...jobs];
        // console.log(temp[index]._id);
        // dispatch(deleteJobById(temp[index]._id, {}, (data) => {
        //     temp.splice(index, 1);
        //     setJobs(temp);
        //     enqueueSnackbar("Job deleted successfully", { variant: 'success' });
        // }, (err) => {
        //     enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        // }))
    }




    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
        <Layout>
            <UserLayout userRole={"coach"}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        mt: 8,
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Upcoming Service(s) Sessionss</Typography>

                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search"
                        onChange={handleSearch}
                        InputProps={{
                            endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                        }}
                    />
                </Box>


                <Paper sx={{ px:{md:5, xs:1}, my:3,  boxShadow: 'none', border: '1px solid #e0e0e0' }} >
                    <Grid container my={2} >
                        <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                            <Typography className='text2Bold'>Filter</Typography>
                            <select
                                style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'

                                value={selectedOption}
                                onChange={handleChange}
                            >
                                <option value="">None</option>
                                <option value="option1">Option 1</option>
                                <option value="option2">Option 2</option>
                                <option value="option3">Option 3</option>
                            </select>
                        </Grid>
                        <Grid item md={5}></Grid>

                        <Grid item md={3} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                            <select
                                style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'

                                value={selectedOption}
                                onChange={handleChange}
                            >
                                <option value="">Sort by date</option>
                                <option value="option1">Option 1</option>
                                <option value="option2">Option 2</option>
                                <option value="option3">Option 3</option>
                            </select>
                        </Grid>
                    </Grid >

                    <Paper sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                        <Grid container>
                            <Grid item xs={12}>
                                <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                                    <Table width="auto">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Candidate
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Service
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Date & Time
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Duration
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Upcoming Session/Duration
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Join Here
                                                </TableCell>
                                                <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                    Status
                                                </TableCell>


                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : data
                                            ).map((row) => (
                                                <TableRow key={row.id}>
                                                    <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE' }}>
                                                        Anuj Sharma
                                                    </TableCell>
                                                    <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', }}>
                                                        UI-UX Designer
                                                    </TableCell>
                                                    <TableCell style={{ width: 'fit-content', textAlign: 'center' }}>
                                                        12/04/2023 2:00PM
                                                    </TableCell>
                                                    <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>60 Minutes</TableCell>
                                                    <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>2/3 Session</TableCell>
                                                    <TableCell style={{ width: 'fit-content', textAlign: 'center' }}>
                                                        <IconButton>
                                                            <VideocamIcon style={{ color: "#2544EE" }} />
                                                        </IconButton>
                                                    </TableCell>

                                                    <TableCell style={{ width: 'fit-content', textAlign: 'center' }}>
                                                        <select
                                                            className='profile-skills-box text2Light'
                                                            value={selectedOption}
                                                            onChange={handleChange1}
                                                            style={{
                                                                color: selectedOption === "In Progress" ? '#FFBF75' :
                                                                    selectedOption === "Upcoming" ? '#2544EE' :
                                                                        selectedOption === "Reschedule" ? '#CC8B8B' : '#000',
                                                                        fontWeight: selectedOption ? 'bold' : 'normal',

                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="In Progress">In Progress</option>
                                                            <option value="Upcoming">Upcoming</option>
                                                            <option value="Reschedule">Reschedule</option>
                                                        </select>
                                                    </TableCell>

                                                </TableRow>
                                            ))}

                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={8} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Paper>
            </UserLayout>
        </Layout>

    );
}
